'use strict';

module.exports = {
  CHALLENGE: 'challenge',
  GROUP: 'group',

  // We set the resource type as `tribe`
  // but the target is a `tribeCollection`
  TRIBE: 'tribe',
};
